import MAutoComplete from './AutoComplete.vue';

export default MAutoComplete;
